import type { Player } from '@schibsted-svp/web-player';
import type { StreamProvider } from '@vgtv/api-client';
import { getRawAsset } from './asset';

export const getConfigProvider = (player: Player): StreamProvider => {
  return player.getRawConfig().vendor as StreamProvider;
};

export const getAssetProvider = (
  player: Player
): StreamProvider | 'brandstudio' => {
  return getRawAsset(player)?.provider || getConfigProvider(player);
};

export const getJWPlayerProvider = (player: Player) => {
  return player.getJWPlayer()?.getProvider()?.name;
};
